<template>
  <div id="tableauViz" v-resize="onResize" />
</template>

<script>
import { TableauViz, TableauEventType } from '@tableau/embedding-api';

import { Debouncer } from '../../libraries/common';
export default {
  props: ['modelData', 'filterName', 'availableFilters', 'availableParameters'],
  data() {
    return {
      viz: null,
      debouncer: new Debouncer(100),
    };
  },
  computed: {
    templateName() {
      return this.$store.state.user.user.email;
    },
  },
  methods: {
    initViz() {
      this.viz = new TableauViz();
      this.viz.src = this.modelData.url;
      this.viz.toolbar = 'hidden';
      this.viz.token = this.modelData.token;

      document.getElementById('tableauViz').appendChild(this.viz);

      this.viz.addEventListener(TableauEventType.FilterChanged, this.onFilterSelection);
      this.viz.addEventListener(TableauEventType.ParameterChanged, this.onParameterSelection);
      this.viz.addEventListener(TableauEventType.TabSwitched, () => window.scrollTo(0, 0));
    },
    onFilterSelection(event) {
      this.debouncer.clear()
        .push(() => this.viz.workbook
          .saveCustomViewAsync(this.templateName)
          .then(() => this.viz.workbook.setActiveCustomViewAsDefaultAsync())
        );
    },
    onParameterSelection(event, data) {
      this.debouncer.clear()
        .push(() => this.viz.workbook
          .saveCustomViewAsync(this.templateName)
          .then(() => this.viz.workbook.setActiveCustomViewAsDefaultAsync())
        );
    },
    undoAction() {
      this.viz.undoAsync();
    },
    resetFilters() {
      this.viz.workbook
        .removeCustomViewAsync(this.templateName)
        .then(() => this.viz.workbook.showCustomViewAsync(this.templateName));
    },
    onResize() {
      if (this.viz) {
        this.viz.width = `${this.$el.clientWidth}px`;
        this.viz.height = `${this.$el.clientHeight}px`;
        this.viz.setFrameSize();
      }
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisTableauView'] = this;
    this.initViz();
  },
}
</script>

<style lang="scss" scoped>
.tableau-view {
  width: 100%;
  height: 801px;
}
</style>